var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { hasPermission } from "../../services/getNavigationPages";
import showToast from "../../services/toast";
import { showErrorToast } from "../../fnx/showError";
import { useGeneralCatalogGetAll } from "../../fnx/generalCatalog/generalCatalogGetAll";
import { optionSelect, optionsSelectClient, selectValueDefault, } from "./generalCatalogDto";
import { useGeneralCatalogPost } from "../../fnx/generalCatalog/generalCatalogPost";
import { useGeneralCatalogPatch } from "../../fnx/generalCatalog/generalCatalogPatch";
import { useTranslation } from "react-i18next";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var GeneralCatalogAdmin = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _a = useState([]), listGeneralCatalog = _a[0], setListGeneralCatalog = _a[1];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(false), triggerPost = _c[0], setTriggerPost = _c[1];
    var _d = useState(false), triggerPatch = _d[0], setTriggerPatch = _d[1];
    var _e = useState(""), idGeneralCatalog = _e[0], setIdGeneralCatalog = _e[1];
    var _f = useState(), valueType = _f[0], setValueType = _f[1];
    var _g = useState(), valueCode = _g[0], setValueCode = _g[1];
    var _h = useState(), valueDescription = _h[0], setValueDescription = _h[1];
    var _j = useState(1), pageCatalog = _j[0], setPageCatalog = _j[1];
    var _k = useState(20), limitCatalog = _k[0], setLimitCatalog = _k[1];
    var _l = useState(0), countPagination = _l[0], setCountPagination = _l[1];
    var _m = useState({
        data: {
            clientId: "",
        },
    }), bodyRequest = _m[0], setBodyRequest = _m[1];
    var _o = useState(false), openModal = _o[0], setOpenModal = _o[1];
    var _p = useState(false), openModalConfirm = _p[0], setOpenModalConfirm = _p[1];
    var _q = useState(false), openModalCloneConfirm = _q[0], setOpenModalCloneConfirm = _q[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _r = useState(false), isUpdate = _r[0], setIsUpdate = _r[1];
    var _s = useState(null), itemModal = _s[0], setitemModal = _s[1];
    /*Para los campos del formulario*/
    var _t = useState({
        Id: "",
        Type: "",
        Code: "",
        Description: "",
    }), dataForm = _t[0], setDataForm = _t[1];
    var _u = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _u[0], setSeeToast = _u[1];
    var permissions = {
        create: hasPermission("admin-catalog-create"),
        edit: hasPermission("admin-catalog-edit"),
        delete: hasPermission("admin-catalog-delete"),
    };
    /*Llamada al getAll para recuperar todos los registros*/
    var _v = useGeneralCatalogGetAll(trigger, clientId, valueType, valueCode, valueDescription, pageCatalog, limitCatalog), responseGeneralCatalog = _v.responseGeneralCatalog, errorGeneralCatalog = _v.errorGeneralCatalog, loadingGeneralCatalog = _v.loadingGeneralCatalog;
    /*Llamada al POST */
    var _w = useGeneralCatalogPost(triggerPost, bodyRequest), responseGeneralCatalogPost = _w.responseGeneralCatalogPost, errorGeneralCatalogPost = _w.errorGeneralCatalogPost, loadingGeneralCatalogPost = _w.loadingGeneralCatalogPost;
    /*Llamada al PATCH*/
    var _x = useGeneralCatalogPatch(triggerPatch, bodyRequest, idGeneralCatalog), responseGeneralCatalogPatch = _x.responseGeneralCatalogPatch, errorGeneralCatalogPatch = _x.errorGeneralCatalogPatch, loadingGeneralCatalogPatch = _x.loadingGeneralCatalogPatch;
    // const { responseDeleteEntity, loadingDeleteEntity, errorDeleteEntity } =
    //   useSelector((state: any) => ({
    //     responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
    //     loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
    //     errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    //   }));
    /*Call Trigger para GetAll*/
    var callGeneralCatalog = function () {
        setTrigger(!trigger);
    };
    useEffect(function () {
        callGeneralCatalog();
    }, []);
    /*Call Trigger para post*/
    var callGeneralCatalogPost = function () {
        setTriggerPost(!triggerPost);
    };
    /*Call Trigger para Patch*/
    var callGeneralCatalogPatch = function () {
        setTriggerPatch(!triggerPatch);
    };
    /*Valida respuesta del getAll y mapea objetos*/
    useEffect(function () {
        var _a, _b;
        if (responseGeneralCatalog && ((_a = responseGeneralCatalog.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var listGeneralCatalog_1 = responseGeneralCatalog === null || responseGeneralCatalog === void 0 ? void 0 : responseGeneralCatalog.data.map(function (item) { return ({
                id: item.id,
                type: item.type,
                code: item.code,
                description: item.description,
                clientId: item.clientId,
                fontSizeType: 11,
                fontSizeDescription: 12,
                codeLabel: "Codigo: ",
                typeLabel: "Tipo: ",
            }); });
            setListGeneralCatalog(listGeneralCatalog_1);
            setTrigger(false);
        }
        else if (responseGeneralCatalog &&
            ((_b = responseGeneralCatalog.data) === null || _b === void 0 ? void 0 : _b.length) == 0) {
            setTrigger(false);
            setListGeneralCatalog([]);
        }
        if (responseGeneralCatalog === null || responseGeneralCatalog === void 0 ? void 0 : responseGeneralCatalog.pagingInfo) {
            setCountPagination(responseGeneralCatalog === null || responseGeneralCatalog === void 0 ? void 0 : responseGeneralCatalog.pagingInfo.totalItems);
        }
    }, [responseGeneralCatalog]);
    /*Valida respuesta cuando ya se inserto el registro*/
    useEffect(function () {
        if (responseGeneralCatalogPost) {
            setSeeToast({
                show: true,
                message: "Creado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            setTriggerPost(false);
            callGeneralCatalog();
        }
    }, [responseGeneralCatalogPost]);
    /*Valida respuesta cuando ya se actualizo el registro*/
    useEffect(function () {
        if (responseGeneralCatalogPatch) {
            setSeeToast({
                show: true,
                message: "Registro actualizado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            setTriggerPatch(false);
            callGeneralCatalog();
        }
    }, [responseGeneralCatalogPatch]);
    /*Muestra si tubo errores el GET ALL de Catalogo General*/
    useEffect(function () {
        if (errorGeneralCatalog) {
            showErrorToast(errorGeneralCatalog, setSeeToast, t);
        }
    }, [errorGeneralCatalog]);
    /*Muestra si tubo errores el POST de Catalogos Generales*/
    useEffect(function () {
        if (errorGeneralCatalogPost) {
            showErrorToast(errorGeneralCatalogPost, setSeeToast, t);
        }
    }, [errorGeneralCatalogPost]);
    /*Muestra si tubo errores el Patch de Catalogos Generales*/
    useEffect(function () {
        if (errorGeneralCatalogPatch) {
            showErrorToast(errorGeneralCatalogPatch, setSeeToast, t);
        }
    }, [errorGeneralCatalogPatch]);
    var menuItem = [
        {
            disabled: hasPermission("admin-catalog-edit") ? false : true,
            icon: {
                color: "#006ac6",
                icon: icons.Edit,
                size: sizesIcon.standard,
            },
            id: "1",
            name: "Editar",
        },
        {
            icon: {
                color: "#006ac6",
                icon: icons.Delete,
                size: sizesIcon.standard,
            },
            disabled: hasPermission("admin-catalog-delete") ? false : true,
            id: "2",
            name: "Eliminar",
        },
        // {
        //   icon: {
        //     color: "#006ac6",
        //     icon: icons.FileCopy,
        //     size: sizesIcon.standard,
        //   },
        //   disabled: false,
        //   id: "3",
        //   name: "Clonar",
        // },
    ];
    // useEffect(() => {
    //   if (responseDeleteEntity) {
    //     setSeeToast({
    //       show: true,
    //       message: "Eliminado con éxito",
    //       type: typeAlert.success,
    //     });
    //     setTimeout(() => {
    //       setSeeToast({
    //         show: false,
    //         message: "",
    //         type: typeAlert.success,
    //       });
    //     }, 3000);
    //     setOpenModal(false);
    //     dispatch(deleteEntityClearData());
    //     setTrigger(true);
    //   } else if (errorDeleteEntity) {
    //     setSeeToast({
    //       show: true,
    //       message: errorDeleteEntity?.message.message,
    //       type: typeAlert.error,
    //     });
    //     setTimeout(() => {
    //       setSeeToast({
    //         show: false,
    //         message: "",
    //         type: typeAlert.error,
    //       });
    //     }, 3000);
    //   }
    // }, [responseDeleteEntity, errorDeleteEntity]);
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { Id: row.id, Type: row.type, Code: row.code, Description: row.description, clientId: clientId }));
    };
    /*Submit para actualizar o agregar un registro*/
    var handleSubmitGeneralCatalog = function (dataProject) {
        if (isUpdate) {
            /*Se llena la informacion al momento de acutalizar*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    clientId: clientId,
                    type: dataProject.Type,
                    code: dataProject.Code,
                    description: dataProject.Description,
                },
            });
            // Se asigna el id del ProjectType para a actualizar
            setIdGeneralCatalog(dataForm.Id);
            /*Llamda al FNX para actualizar PATCH*/
            callGeneralCatalogPatch();
        }
        else {
            /*Se procede a crear un nuevo Registro*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    clientId: clientId,
                    type: dataProject.Type,
                    code: dataProject.Code,
                    description: dataProject.Description,
                },
            });
            /*Llamada al FNX para crear Registro*/
            callGeneralCatalogPost();
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalConfirm = function () {
        setOpenModalConfirm(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var onClickClearData = function (Data) {
        // Valida clean filtro y limpia los filtros
        if (Data.filter.type_filter === "empty") {
            setValueDescription(undefined);
            setValueCode(undefined);
            setValueType(undefined);
        }
        // Llama a la consulta general sin filtros
        callGeneralCatalog();
    };
    var onClickApplyFilter = function (Data) {
        if (Data.filter.type_filter === "type") {
            setValueType(Data.filter.filter_value);
            setValueCode(undefined);
            setValueDescription(undefined);
        }
        else if (Data.filter.type_filter === "code") {
            setValueCode(Data.filter.filter_value);
            setValueDescription(undefined);
            setValueType(undefined);
        }
        else if (Data.filter.type_filter === "description") {
            setValueDescription(Data.filter.filter_value);
            setValueCode(undefined);
            setValueType(undefined);
        }
        callGeneralCatalog();
    };
    var handleSelectChange = function (event) {
        console.log("Event", event);
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenModal(true);
        setDataForm(__assign(__assign({}, dataForm), { Id: "", Type: "", Code: "", Description: "" }));
    };
    var onClickContextsMenu = function (opt, card) {
        if (opt.id === "1") {
            // Opcion Editar
            setIsUpdate(true);
            setOpenModal(true);
            showEdit(card);
        }
        else if (opt.id === "2") {
            // Opcion eliminar
            // setitemModal(item);
            // setOpenModalConfirm(true);
            setSeeToast({
                show: true,
                message: "Operación no permitida!",
                type: typeAlert.warning,
            });
            setOpenModal(false);
        }
        // else if (opt.id === "3") {
        //   setitemModal(item);
        //   setOpenModalCloneConfirm(true);
        // }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseModalConfirm = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    /*Api que se ejecuta cuando el catalogo tiene la opcion
     * para eliminar registros*/
    var handleDelete = function () {
        setSeeToast({
            show: true,
            message: "Operación no permitida!",
            type: typeAlert.warning,
        });
        setOpenModal(false);
    };
    var handleClone = function () { };
    var onChangeRowsPerPage = function (e) {
        setLimitCatalog(e);
        setTrigger(true);
    };
    var onChangePage = function (e) {
        setPageCatalog(e);
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingGeneralCatalog, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando sponsor..." }), _jsx(View, { title: "Catalogos Generales", permissions: permissions, generalCatalogTitle: isUpdate ? "Modificar Catalogo General" : "Agregar Catalogo General", list: listGeneralCatalog, openModal: openModal, openModalConfirm: openModalConfirm, openModalCloneConfirm: openModalCloneConfirm, loadingPost: null, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseConfirm: handleCloseModalConfirm, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalConfirm: handleOpenModalConfirm, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onFilterApply: onClickApplyFilter, onSaveData: handleSubmitGeneralCatalog, onClickAdd: handleOnClickAdd, menuItem: menuItem, onClickContextMenu: onClickContextsMenu, onClickCancel: handleCloseModal, optionsSelect: optionSelect, onChangeSelect: handleSelectChange, onFilterEmpty: onClickClearData, selectValueDefault: selectValueDefault, inputHeigth: "20.3px", clientFilterLbl: "Cliente", optionsSelectClient: optionsSelectClient, countPagination: countPagination, limitCatalog: limitCatalog, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage, pageCatalog: pageCatalog })] }));
};
export default GeneralCatalogAdmin;
